<ev-dialog
    [visible]="showDialog()"
    [title]="'Lag rapport'"
    [theme]="'green'"
    [showConfirmLoader]="showLoader()"
    [disabledConfirm]="showLoader()"
    [confirmText]="'Lag rapport'"
    [cancelText]="'Avbryt'"
    (close)="onClose.emit(true)"
    (confirm)="confirmReport(true)"
>
    <div class="wizard-wrapper">
        <div class="header">
            <div class="title">
                @if (filterForm.searchViewOptions.periodDefinitionType().value() === periodType.Registered) {
                    <div>Registrert i perioden</div>
                } @else if (filterForm.searchViewOptions.periodDefinitionType().value() === periodType.Sold) {
                    <div>Solgt i perioden</div>
                } @else if (filterForm.searchViewOptions.periodDefinitionType().value() === periodType.InMarket) {
                    <div>I markedet i perioden</div>
                } @else {
                    <div>Statistikk</div>
                }
            </div>
            <div class="graphics period-header">
                <div>{{ computedTimePeriod().fromDate | date: "shortDate" }}</div>
                <div class="left-arrow"></div>
                <div
                    class="period-type-icon"
                    [class.registered-icon]="filterForm.searchViewOptions.periodDefinitionType().value() === periodType.Registered"
                    [class.sold-icon]="filterForm.searchViewOptions.periodDefinitionType().value() === periodType.Sold"
                    [class.inmarket-icon]="filterForm.searchViewOptions.periodDefinitionType().value() === periodType.InMarket"
                ></div>
                <div class="right-arrow"></div>
                <div>{{ computedTimePeriod().toDate | date: "shortDate" }}</div>
            </div>
        </div>
        <div class="content">
            <div class="coloumn left" [class.has-warning]="!hasDemographicsRole() || !hasAllowedEstateTypeMix">
                <div class="coloumn-header"></div>
                <div class="graphics">
                    <img src="assets/images/statisticsreport.png" alt="" />
                </div>
            </div>
            <div class="coloumn mid">
                <div class="mid-wrapper">
                    <div class="coloumn-header"></div>
                    <div class="choices">
                        <div class="title">Inkluder i rapport</div>
                        <div class="choice">
                            <div
                                class="checkbox-icon"
                                [class.selected]="reportWizardCheckItems.prices"
                                [class.disabled]="showLoader() || !hasReportData.priceStatistics"
                                (click)="reportWizardCheckItems.prices = !reportWizardCheckItems.prices"
                            ></div>
                            <span class="checkbox-label" [class.disabled]="showLoader() || !hasReportData.priceStatistics">Prisstatistikk</span>
                        </div>
                        <div class="choice">
                            <div
                                class="checkbox-icon"
                                [class.selected]="reportWizardCheckItems.matrixes"
                                [class.disabled]="showLoader() || !hasReportData.priceStatistics"
                                (click)="reportWizardCheckItems.matrixes = !reportWizardCheckItems.matrixes"
                            ></div>
                            <span class="checkbox-label" [class.disabled]="showLoader() || !hasReportData.priceStatistics">Matriser</span>
                        </div>
                        @if (hasDemographicsRole()) {
                            <div class="choice">
                                <div
                                    class="checkbox-icon"
                                    [class.selected]="reportWizardCheckItems.demographyBuyers"
                                    [class.disabled]="!hasDemographicsRole() || !hasAllowedEstateTypeMix || showLoader() || !hasReportData.demography"
                                    (click)="reportWizardCheckItems.demographyBuyers = hasDemographicsRole() ? !reportWizardCheckItems.demographyBuyers : false"
                                ></div>
                                <span
                                    class="checkbox-label"
                                    [class.disabled]="!hasDemographicsRole() || !hasAllowedEstateTypeMix || showLoader() || !hasReportData.demography"
                                    >Demografi: kjøpere</span
                                >
                            </div>
                        }
                        @if (hasDemographicsRole()) {
                            <div class="choice">
                                <div
                                    class="checkbox-icon"
                                    [class.selected]="reportWizardCheckItems.demographyResidents"
                                    [class.disabled]="!hasDemographicsRole() || !hasAllowedEstateTypeMix || showLoader() || !hasReportData.areaInhabitantDemography"
                                    (click)="
                                        reportWizardCheckItems.demographyResidents = hasDemographicsRole() ? !reportWizardCheckItems.demographyResidents : false
                                    "
                                ></div>
                                <span
                                    class="checkbox-label"
                                    [class.disabled]="!hasDemographicsRole() || !hasAllowedEstateTypeMix || showLoader() || !hasReportData.areaInhabitantDemography"
                                    >Demografi: innbyggere</span
                                >
                            </div>
                        }
                        @if (hasMarketSharesRole()) {
                            <div class="choice">
                                <div
                                    class="checkbox-icon"
                                    [class.selected]="reportWizardCheckItems.estateAgentMarketShares"
                                    [class.disabled]="!hasMarketSharesRole || showLoader() || !hasReportData.marketShares"
                                    (click)="
                                        reportWizardCheckItems.estateAgentMarketShares = hasMarketSharesRole()
                                            ? !reportWizardCheckItems.estateAgentMarketShares || !hasReportData.marketShares
                                            : false
                                    "
                                ></div>
                                <span class="checkbox-label" [class.disabled]="!hasMarketSharesRole() || showLoader() || !hasReportData.marketShares"
                                    >Markedsandeler megler</span
                                >
                            </div>
                        }
                        <div class="choice" style="position: relative">
                            <div
                                class="checkbox-icon"
                                [class.selected]="reportWizardCheckItems.areaComparison"
                                [class.disabled]="hasReportData.hasTooManyOrFewAreas || showLoader()"
                                (click)="reportWizardCheckItems.areaComparison = !reportWizardCheckItems.areaComparison"
                            ></div>
                            <span class="checkbox-label" [class.disabled]="hasReportData.hasTooManyOrFewAreas || showLoader()">Områdesammenligning</span>
                            <div class="tooltip">
                                <div
                                    class="info-icon"
                                    (click)="areaComparisionToolTipEnabled = !areaComparisionToolTipEnabled"
                                    (clickOutside)="areaComparisionToolTipEnabled = false"
                                >
                                    <ev_tooltip
                                        [visible]="areaComparisionToolTipEnabled"
                                        [right]="-125"
                                        [bottom]="25"
                                        [arrow]="'bottom'"
                                        [arrowAlignLeft]="8"
                                        title="Områdesammenligning"
                                    >
                                        Sammenlign opptil 4 områder fra områdevelgeren eller tegnede områder.
                                    </ev_tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (hasDemographicsRole() && !hasAllowedEstateTypeMix) {
                <div [class.has-no-warning]="hasDemographicsRole() && hasAllowedEstateTypeMix" class="coloumn right">
                    <div class="coloumn-header">
                        <div class="icon alert"></div>
                    </div>
                    <p class="bold">Demografi ikke tilgjengelig</p>
                    <p>Fritidsbolig kan ikke kombineres med andre boligtyper.</p>
                    <p>For å inkludere demografi, juster filteret til å kun vise fritidsbolig eller å kun vise alle andre boligtyper.</p>
                </div>
            } @else if (hasReportData.demographyLimitReached) {
                <div [class.has-no-warning]="hasDemographicsRole() && hasAllowedEstateTypeMix" class="coloumn right">
                    <div class="coloumn-header">
                        <div class="icon alert"></div>
                    </div>
                    <p class="bold">Demografi:kjøpere ikke tilgjengelig</p>
                    <p>
                        Området du har valgt er for stort til å generere demografi-statistikk. Reduser antall områder eller størrelsen på området for å generere
                        statistikk
                    </p>
                </div>
            } @else {
                <div [class.has-no-warning]="hasDemographicsRole() && hasAllowedEstateTypeMix" class="coloumn right"></div>
            }
        </div>
    </div>
</ev-dialog>
